import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetResultByDivisionEngagement state domain
 */

const selectWidgetResultByDivisionEngagementDomain = (state) =>
  state.get("widgetResultByDivisionEngagement", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingDivisions = () =>
  createSelector(selectWidgetResultByDivisionEngagementDomain, (state) =>
    state.get("isLoadingDivisions")
  )

export const makeSelectDivisionsDrillDown = () =>
  createSelector(selectWidgetResultByDivisionEngagementDomain, (state) =>
    state.get("divisionsDrillDown")
  )

export const makeSelectDimensions = () =>
  createSelector(selectWidgetResultByDivisionEngagementDomain, (state) =>
    state.get("dimensions")
  )

export const makeSelectMetric = () =>
  createSelector(selectWidgetResultByDivisionEngagementDomain, (state) =>
    state.get("metric")
  )

/**
 * Default selector used by WidgetResultByDivisionEngagement
 */

const makeSelectWidgetResultByDivisionEngagement = () =>
  createSelector(selectWidgetResultByDivisionEngagementDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDivisionEngagement
export { selectWidgetResultByDivisionEngagementDomain }
